/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientMedicalHistoryApi } from '../api/patientmedicalhistory.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientMedicalHistory,PatientMedicalHistoryData} from '../../../interfaces/masters/patientMedicalHistory';

@Injectable()
export class PatientMedicalHistoryService extends PatientMedicalHistoryData {

  constructor(private api: PatientMedicalHistoryApi) {
    super();
  }


  list(url: string): Observable<PatientMedicalHistory[]> {
    return this.api.list(url);
  }
  listForDia(url: string): Observable<any[]> {
    return this.api.listForDia(url);
  }
  medicalHistoryReport(url: string): Observable<any[]> {
    return this.api.reportList(url);
  } 

  getById(url: string): Observable<PatientMedicalHistory> {
    return this.api.getById(url);
  }

  create(url: string, data: PatientMedicalHistory): Observable<PatientMedicalHistory> {
    return this.api.add(url, data);
  }

  createPatientFamilyHistory(url: string, data: PatientMedicalHistory[]): Observable<PatientMedicalHistory> {
    return this.api.addPatientFamilyHistory(url, data);
  }
    

  update(url: string, data: PatientMedicalHistory): Observable<PatientMedicalHistory> {
    return this.api.update(url, data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
